var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"LoadingModal","title":"Info","hide-footer":"","hide-header":"","centered":"","no-close-on-esc":"","no-close-on-backdrop":"","body-bg-variant":_vm.bodyBgVariant,"body-text-variant":_vm.bodyTextVariant}},[_c('p',{staticClass:"my-4 text-center"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }